// User
import userList from '../pages/users/users.vue';
import newUser from '../pages/users/newUser.vue';
import userProfile from '../pages/users/user.vue';
import profilePage from '../pages/users/profile.vue';
import userRoles from '../pages/users/roles.vue';

const userRoutes = [
  { // /users/roles
    path: '/users/roles',
    name: 'users-role',
    component: userRoles,
    meta:{
      name: 'User Role',
      requireAuth: true
    },
  },
  { // /users
    path: '/users/new',
    name: 'add-user',
    component: newUser,
    meta:{
      name: 'New User',
      requireAuth: true
    },
  },
  { // /users
    path: '/users',
    name: 'users',
    component: userList,
    meta:{
      name: 'Users',
      requireAuth: true
    },
  },
  { // /profile
    path: '/profile',
    name: 'profile',
    component: profilePage,
    meta:{
      name: 'Profile',
      requireAuth: true
    },
  },
  { // /user/:id
    path: '/user/:id',
    name: 'user',
    component: userProfile,
    meta:{
      name: 'User',
      requireAuth: true
    },
    props: true
  },
]

export default userRoutes